<script setup lang="ts">
import { tv } from 'tailwind-variants'

defineProps<{
  variant: PacketVariant
}>()

const variants = tv({
  variants: {
    theme: {
      // FIXME: ATM, these are all the same, because three of the themes are missing design for this component.
      'green-seagreen': 'bg-coral-legacy-10',
      'dark-red-pink': 'bg-coral-legacy-10',
      'green-red': 'bg-coral-legacy-10',
      'blue-pink': 'bg-coral-legacy-10',
    },
  },
})

const packet = inject(keys.currentPacket)

const auth = useAuthorizeStore()

const classes = computed(() => variants({ theme: unref(packet)?.theme }))
</script>

<template>
  <PacketAddWidget
    v-slot="{ title }"
    :variant="variant"
    class="@container flex flex-col gap-legacy-m rounded-md p-legacy-s md:rounded-lg md:p-legacy-m"
    :class="classes"
    card-class="p-legacy-s @sm:px-legacy-m"
  >
    <div class="flex grow flex-col gap-legacy-2xs text-black-80">
      <h4 class="text-xl font-semibold md:text-2xl" v-text="title" />
      <p
        v-if="variant.subtitle"
        class="text-lg leading-7! font-semibold md:text-xl"
        v-text="variant.subtitle"
      />
      <VariantDescription :variant="variant" />
    </div>

    <PacketQuantityInput v-if="!isConsumer(auth.user)" :variant="variant" />
  </PacketAddWidget>
</template>
